import { createFileRoute } from '@tanstack/react-router'
import Announcement from '@/components/common/Announcement/Announcement'
import { Link } from '@/components/common/Announcement/components'
import { SUPPORT_URL } from '@/config/settings'
import { openLink } from '@/helpers'
import {Button} from "@/components/common/Button";

function SignUpPage() {
  return (
    <Announcement
      type="default"
      modal={true}
      title="No Account Found"
      subTitle="Install GameGlass Hub to get started"
    >
      <>
        <Button
          primary
          wrap={false}
          onClick={() => openLink('https://profile.gameglass.gg/sign-up')}
        >
          Sign Up & Download GameGlass Hub
        </Button>
        <Link href={SUPPORT_URL}>{'Get help'}</Link>
      </>
    </Announcement>
  )
}

export const Route = createFileRoute('/signup')({
  component: SignUpPage,
})
